import axios from '@/libs/http'
import {appendIfNotEmpty, setIfNotEmpty} from "@/libs/util";

/**
 * 获取订单列表
 */
export const getOrderList = (keyword, pageNo, pageSize, types, status) => {
    let data = new URLSearchParams()
    if(keyword != null && keyword != ''){
        data.append("keyword", keyword)
    }
    data.append("pageNo", pageNo)
    data.append("pageSize", pageSize)
    data.append("types", types)
    data.append("status", status)
    return axios.request({
        url: '/s/a/order/list',
        data,
        method: 'post'
    })
}
/**
 * 获取订单详情
 */
export const getOrder = (id) => {
    return axios.request({
        url: '/s/a/order/get',
        params: {
            id
        },
        method: 'get'
    })
}

/**
 * 获取订单续单申请列表
 */
export const continuedApplyList = (status, keyword, pageNo, pageSize) => {
    let data = new URLSearchParams()
    if (status != null) {
        data.append("status", status)
    }
    if (keyword != null) {
        data.append("keyword", keyword)
    }
    data.append("pageNo", pageNo)
    data.append("pageSize", pageSize)
    return axios.request({
        url: '/s/a/order/continuedApplyList',
        data,
        method: 'post'
    })
}

/**
 * 审核
 */
export const verifyOrderContinuedApply = (id, status,reason) => {
    return axios.request({
        url: '/s/a/order/verify',
        params: {
            id,
            status,
            reason
        },
        method: 'post'
    })
}

/**
 * 店员业绩
 */
export const statisticsClerkOrder = (id, name, sex, groupId, isDisabled, startTime, endTime, pageNo, pageSize) => {
    let data = new URLSearchParams()
    appendIfNotEmpty(data,'id',id)
    appendIfNotEmpty(data,'name',name)
    appendIfNotEmpty(data,'sex',sex)
    appendIfNotEmpty(data,'groupId',groupId)
    appendIfNotEmpty(data,'isDisabled',isDisabled)
    data.append('startTime',startTime)
    data.append('endTime',endTime)
    data.append('pageNo',pageNo)
    data.append('pageSize',pageSize)
    return axios.request({
        url: '/s/a/statistics/statisticsClerkOrder',
        data,
        method: 'post'
    })
}


/**
 * 获取退款订单
 * */
export const getRefundOrder = (orderId) => {
    return axios.request({
        url: '/s/a/order/getRefundOrder',
        params: {
            orderId
        },
        method: 'get'
    })
}

/**
 * 发起退款
 */
export const refund = (orderId, refundFee,refundDesc,refundPath,refundScene,problemType) => {
    let params = {
        orderId,refundFee,refundDesc,refundPath
    }
    setIfNotEmpty(params,'refundScene',refundScene)
    setIfNotEmpty(params,'problemType',problemType)
    return axios.request({
        url: '/s/a/order/refundV2',
        params,
        method: 'post'
    })
}

/**
 * 首续单转换
 */
export const orderFirstOrContinueChange = (id,type,applyId)=> {
    let data = new URLSearchParams()
    data.append('id',id)
    data.append('type',type)
    if(applyId !== null) {
        data.append('applyId', applyId)
    }
    return axios.request({
        url: '/s/a/order/firstOrContinueCoversion/orderFirstOrContinueChange',
        data,
        method: 'post'
    })
}
